module.exports = __webpack_public_path__ + "static/img/4-1.3f92d2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/4-1.png
// module id = Zkhg
// module chunks = 0